/*
 *  Copyright (c) 2024 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Config } from '../config'
import { makeRequest } from '../common/index'
import qs from 'qs'

const base_url = Config.admin.api_base_url
const context = Config.admin.context
const endpoint = `/${context}/address`

/**
 * getAddressList
 * 
 * @param token
 * @param params
 * @returns {Promise<*|void>}
 */
export const getAddressList = async function (token, params) {
    const method = 'GET'
    let path = `${endpoint}`
    if (params) {
        const page = params?.page
        const pageSize = params?.pageSize
        const query = qs.stringify(
            { pagination: { page, pageSize } },
            { encodeValuesOnly: true }
        )
        path = `${path}?${query}`
    }
    const headers = {"Authorization": `Bearer ${token}`}
    const payload = undefined
    return await makeRequest(method, base_url, path, headers, payload)
}

/**
 * searchAddress
 *
 * @param token
 * @param params
 * @param payload
 * @returns {Promise<*|void>}
 */
export const searchAddress = async function (token, params, payload) {
    const method = 'POST'
    let path = `${endpoint}/search`
    if (params) {
        const page = params.page
        const pageSize = params.pageSize
        const query = qs.stringify(
            { pagination: { page, pageSize }},
            { encodeValuesOnly: true }
        )
        path = `${path}?${query}`
    }
    const headers = {"Authorization": `Bearer ${token}`}
    return await makeRequest(method, base_url, path, headers, payload)
}

/**
 * autocompleteAddress
 * 
 * @param token
 * @param payload
 * @returns {Promise<*|void>}
 */
export const autocompleteAddress = async function (token, payload) {
    const method = 'POST'
    let path = `${endpoint}/autocomplete`
    const headers = {"Authorization": `Bearer ${token}`}
    return await makeRequest(method, base_url, path, headers, payload)
}

/**
 * getAddress
 * 
 * @param token
 * @param guid
 * @returns {Promise<*|void>}
 */
export const getAddress = async function (token, guid) {
    const method = 'GET'
    const path = `${endpoint}/${guid}`
    const headers = {"Authorization": `Bearer ${token}`}
    const payload = undefined
    return await makeRequest(method, base_url, path, headers, payload)
}

/**
 * createAddress
 * 
 * @param token
 * @param payload
 * @returns {Promise<*|void>}
 */
export const createAddress = async function (token, payload) {
    const method = 'POST'
    const path = `${endpoint}`
    const headers = {"Authorization": `Bearer ${token}`}
    return await makeRequest(method, base_url, path, headers, payload)
}

/**
 * updateAddress
 * 
 * @param token
 * @param guid
 * @param payload
 * @returns {Promise<*|void>}
 */
export const updateAddress = async function (token, guid, payload) {
    const method = 'PUT'
    const path = `${endpoint}/${guid}`
    const headers = {"Authorization": `Bearer ${token}`}
    return await makeRequest(method, base_url, path, headers, payload)
}

/**
 * deleteAddress
 * 
 * @param token
 * @param guid
 * @returns {Promise<*|void>}
 */
export const deleteAddress = async function (token, guid) {
    const method = 'DELETE'
    const path = `${endpoint}/${guid}`
    const headers = {"Authorization": `Bearer ${token}`}
    const payload = undefined
    return await makeRequest(method, base_url, path, headers, payload)
}
